<template>
	<header class="header header_wrap" >
		<div :style="{background: config.num !== 'one'?'-webkit-linear-gradient(right, #4f4f4f 0%, #303030 50%)':''}">
			<div class="page" >
				<el-row :gutter="20">
					<el-col :span="6" style="padding: 0">
						<div class="grid-content" style="text-align: left;display:flex;align-items:center">
							<img class="logo" src="../assets/images/logo_muqiangyun.png" alt="" >
							<!-- <p class="head-tel">400-001-5228</p> -->
							<div class="head-tel">
								<img src="../assets/images/head-tel.png" alt="" >								
								<!-- <span>400-001-5228</span> -->
							</div>
						</div>
					</el-col>
					<el-col :span="18" class="item-box" style="padding: 0">
						<div class="grid-content">
							<el-tabs v-model="activeName" @tab-click="handleClick" >
								<el-tab-pane v-for="item in items" :name="item.id" :key="item.id">
									<div slot="label">{{item.name}}</div>
								</el-tab-pane>
								<el-tab-pane name="six" v-if="!tabVisible">
									<div slot="label">
										<div class="grid-content grid-tab" :class="config.num == 5? 'active':''" @click="goLogin"><img class="person" src="../assets/images/icon_person.png" alt="" style="bottom: -3px;margin-right: 5px;">登录</div>
									</div>
								</el-tab-pane>
								<el-tab-pane name="six" v-else>
									<div slot="label">
										<el-dropdown @visible-change="testVisible" trigger="click">
											<div class="el-dropdown-link grid-content grid-tab" :class="config.num == 'six'? 'active':''">
												<img class="person" src="../assets/images/icon_person.png" alt="">
												<img v-if="level == 1" class="person_vip" src="../assets/images/icon_VIP.png" alt="">
											</div>
											<el-dropdown-menu slot="dropdown">
												<el-dropdown-item style="border-bottom: 1px solid rgb(126,126,126);">{{groupName}}</el-dropdown-item>
												<div style="margin: 12px 0;">
													<el-dropdown-item v-for='(i,idx) in tabTitle' :key="idx">
														<div @click="goPage(i.num)" :class="i.flag?'is-active' :''" >{{i.name}}</div>
													</el-dropdown-item>
												</div>
												<el-dropdown-item style="border-top: 1px solid rgb(126,126,126);" ><div @click="goQuit">退出</div></el-dropdown-item>
											</el-dropdown-menu>
										</el-dropdown>
									</div>
								</el-tab-pane>
							</el-tabs>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>
		<div class="bg-mask"></div>
	</header>
</template>
<script>
	import Bus from '../utils/bus'
	import api from '../utils/api'
	export default {
		props: ['config','userInfo'],
		data() {
			return {
				newTabName:'',
				oldTabName:'',
				flag:true,
				activeName: '',
				groupName:'',
				tabVisible:false,
				tabTitle:[
					{
					name:'个人中心',
					num:1,
					flag:false
				},{
					name:'项目成员管理',
					num:2,
					flag:false
				},{
					name:'合同管理',
					num:3,
					flag:false
				},{
					name:'VIP客户',
					num:4,
					flag:false
				}],
				items: [{
					name:'首页',
					id:'one'
				},{
					name:'案例',
					id:'two'
				},{
					name:'报检报修',
					id:'three'
				},{
					name:'新闻',
					id:'four'
				},{
					name:'我的项目',
					id:'five'
				}
				// ,{
				// 	name:'专家',
				// 	id:'seven'
				// }
				],
				activeIndex: '1',
				activeIndex2: '1',
				level:2,
				isValidate: false, //是否已经验证权限
			};
		},
		created() {
			this.validatePower();
		},
		mounted() {
			Bus.$on('tabSelected', idx => {
				this.tabTitle.map((v,i)=>{
					v.flag = false;
				})
				if(idx == 'first'){
					this.tabTitle[1].flag = true
				}else if(idx == 'second'){
					this.tabTitle[2].flag = true
				}
			})
			
			Bus.$on('validatePower', () => {
				console.log('validatePower ')
				this.validatePower();
			})
			let path = this.$route.path;
			//this.activeName = this.config.num
			if(path == '/'){
				// debugger
				this.activeName = 'one';
				let width  = $(window).width()
				if (width <= 1200) {
					$(".el-tabs__active-bar").css({'left':'17px'})
				}
			}else if(path == '/case'|| path.indexOf('/model') != -1 ){
				this.activeName = 'two';
				this.$nextTick(function(){
					$(".el-tabs__active-bar").css({'left':'-12px'})
				})
			}else if(path == '/repairs'){
				this.activeName = 'three';
			}else if(path == '/news'){
				this.activeName = 'four';
			}else if(path == '/project'){
				this.activeName = 'five';
			}else if(path == '/login' || path == '/user'){
				this.activeName = 'six';
			} else if(path == '/Table'){
				this.activeName = 'seven';
			}
			
			this.setUserInfo()
			$('.header .el-tabs__header').css('margin', '0');
			$('.header .el-tabs__nav-wrap').css('overflow', 'visible');
			$('.header .el-tabs__nav-scroll').css('overflow', 'visible');


		},
		watch: {
			'$route'(to, from) {
				this.validatePower();
				$(".el-tabs__active-bar").css({'display':'block'});
				$(".header").css({'background':'rgba(48,48,48,1)'})
				let path = this.$route.path;
				if(path !== '/user'){
					this.tabTitle.map((v,i)=>{
						console.log(v)
						v.flag = false;
					})
				}
				if(path == '/'){
					this.activeName = 'one';
				}else if(path == '/case'|| path.indexOf('/model') != -1){
					this.activeName = 'two';
					this.$nextTick(function(){
						console.log($(".el-tabs__active-bar"))
						$(".el-tabs__active-bar").css({'left':'-12px'})
					})
				}else if(path == '/repairs'){
					this.activeName = 'three';
				}else if(path == '/news'){
					this.activeName = 'four';
				}else if(path == '/project'){
					this.activeName = 'five';
					// let url = 'https://api.smartfacade.com.cn/earth/init.html?openid=oNr6G5OaDecvlbioKElm7MO1ehMk&token=79a2330010b93890a8f381eeca7d38ecfd10f9f8&v=1.4.3.3'
					// window.location.href = url;
				}else if(path == '/login' || path == '/user'){
					this.activeName = 'six';
				} else if(path == '/Table'){
					this.activeName = 'seven';
				}
			},
			'activeName'(n,o){
				this.newTabName = n;
				this.oldTabName = o;
			},
			userInfo() {
				this.setUserInfo()
			}
		},
		methods: {
			setUserInfo() {
				console.log('this is set user info')
				if(this.userInfo){
					let user_info = JSON.parse(this.userInfo);
					
					this.tabVisible = true;
					this.groupName = user_info.member_nickname;
					this.level = user_info.level;
					localStorage.setItem('level', this.level)
					/*非集团管理员*/
					if(user_info.level !== 1 && user_info.personnel_role !== 1 && user_info.personnel_role !== 2 ){
						this.tabTitle.splice(1)
					}
				}
			},
			testVisible(flag){
				let path = this.$route.path;
				this.flag = flag;
				if(!flag && path !== '/user'){
					this.activeName = this.oldTabName;
				}
			},
			handleClick(tab, event) {
				let idx = this.activeName;
				let path = this.$route.path;
				if(idx == 'one'){
					let width  = $(window).width()
					if (width <= 1200) {
						$(".el-tabs__active-bar").css({'left':'17px'})
					}
				} else if(idx == 'two'){
					this.$nextTick(function(){
						console.log($(".el-tabs__active-bar"))
						$(".el-tabs__active-bar").css({'left':'-12px'})
					})
				} else{
					this.$nextTick(function(){
						console.log($(".el-tabs__active-bar"))
						$(".el-tabs__active-bar").css({'left':'0'})
					})
				}
				// if (idx == 'five') {
				// 	console.log('i am coming')
				// 	$(".header .grid-content").css({'line-height':'62px'})
				// } else {
				// 	console.log('i am coming else')
				// 	$(".header .grid-content").css({'line-height':'52px'})
				// }
				if (idx == 'one') {
					this.$router.push({
						path: '/'
					})
				} else if (idx == 'two') {
					this.$router.push({
						path: '/case'
					})
				} else if (idx == 'three') {
					this.$router.push({
						path: '/repairs'
					})
				} else if (idx == 'four') {
					this.$router.push({
						path: '/news'
					})
				} else if (idx == 'five') {
					this.$router.push({
						path: '/project'
					})
				} else if (idx == 'seven') {
					this.$router.push({
						path: '/Table'
					})
				}
			},
			goQuit(){
				// this.tabVisible = !this.tabVisible
				localStorage.clear();
				// localStorage.removeItem('user_info');
				// localStorage.removeItem('openid');
				// this.$router.push({path:'/login'})
				setTimeout(() => {
					window.location.href = '/login'
					// window.location.reload()
				}, 200)
			},
			goPage(num) {
				if(num == 4) return;
				this.tabTitle.map((v,i)=>{
					if(v.num == num){
						v.flag = true;
					}else{
						v.flag = false;
					}
				})
				
				Bus.$emit('login-on',num); 
				this.$router.push({ name: 'userView', params: { num: num }});
			},
			handleSelect(key, keyPath) {
				console.log(key, keyPath);
			},
			goLogin() {
				this.$router.push({
					path: '/login'
				})
			},
			navto(idx) {
				if (idx == 0) {
					this.$router.push({
						path: '/'
					})
				} else if (idx == 1) {
					this.$router.push({
						path: '/case'
					})
				} else if (idx == 2) {
					this.$router.push({
						path: '/repairs'
					})
				} else if (idx == 3) {
					this.$router.push({
						path: '/news'
					})
				} else if (idx == 4) {
					this.$router.push({
						path: '/project'
					})
				} else if (idx == 5) {
					this.$router.push({
						path: '/Table'
					})
				}
			},
			//验证权限
			validatePower() {
				console.log('validatePower ---- ')
				let param = {
					type: '1git'
				}
				api.getFilter(param).then(res => {
					console.log('getFilter -- res ', res)
					if (res.data.code === 200) {
						this.isValidate = true
						document.title = "深圳市建筑门窗幕墙学会 专家端";
						// this.power = true
						let isExist = true
						this.items.forEach((item ,index) => {
							if (item.id == 'seven') {
								isExist = true
								return
							} else {
								isExist = false
							}		
						})
						if (!isExist) {
							let obj = {
								name:'机构',
								id:'seven'
							}
							this.items.push(obj)
						}
						if (!this.isValidate) {
							this.$router.push({
								path: '/Table'
							})
							this.activeName = 'seven';
						}
						
						
					} else {		
						this.isValidate = false				
						document.title = "智汇幕墙-为每一片幕墙提供专业保障";
						this.items.forEach((item ,index) => {
							if (item.id == 'seven') {
								this.items.splice(index, 1)
							}		
						})
						
						// this.$router.push({
						// 	path: '/'
						// })
						// this.activeName = 'one';
						// this.activeName = 'six';
					}
						console.log('this.items ', this.items)
				})
			},
		}
	};
</script>
<style scoped="scoped">
@import url("../assets/css/media/header/header.css");
	.head-tel {
		margin-left: 30px;
		/* height: 24px;
		line-height: 25px; */
		/* float: left; */
	}
	.head-tel span {
		display: inline-block;
		color: #fff;
		font-weight: 600;
		font-size: 18px;
		letter-spacing: 1px;
		font-family: SourceHanSansCN-Normal;
	}
	.head-tel img {
		width: 170px;
		margin-top: 19px;
		/* border: 1px solid red; */
	}
	.header {
		width: 100%;
		position: fixed;
		top: 0;
		background:rgba(48,48,48,1);
		z-index: 1020;
		overflow: hidden;
	}
	.header .bg-mask {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 10;
		display: none;
		background:rgba(0,0,0, 0.5);
	}

	.header .item-box {
		display: flex;
		justify-content: flex-end;
	}

	.header .grid-content {
		height: 52px;
		line-height: 52px;
		color: #fff;
		text-align: center;
	}

	.header .active {
		background: -webkit-linear-gradient(bottom, rgba(255, 255, 255, .2) 0%, rgba(0, 0, 0, 0) 100%);
	}

	.page {
		margin: 0 auto;
		width: 1200px;
	}

	.grid-tab {
		cursor: pointer;
	}

	.el-dropdown {
		display: block;
	}

	.el-dropdown-menu__item {
		width: 123px;
		box-sizing: border-box;
		padding: 0 18px;
	}

	.el-dropdown-menu {
		padding: 0;
		background: #656565;
		border: 0;
	}

	.el-dropdown-menu__item {
		color: #fff;
	}

	.el-dropdown-menu__item:not(.is-disabled):hover {
		background-color: transparent;
	}

	.el-popper[x-placement^=bottom] .popper__arrow::after {
		border-bottom-color: rgb(101, 101, 101);
	}
	.is-active{
		color: #66b1ff;
	}
	.person{
		width: 16px;
		height: auto;
		position: relative;
		bottom: -5px;
	}
	.person_vip{
		position: absolute;
		top: 18px;
		right: 5px;
	}
	.header .logo{
		width: 120px;
		/* height: 33px; */
		/* top: 9px; */
		/* position: relative; */
	}
</style>



// WEBPACK FOOTER //
// src/components/header.vue